// dropdowns
export const REQUEST_POLICY_TYPE_DD = 'policyTypes/REQUEST_POLICY_TYPE_DD'; 
export const RECEIVE_POLICY_TYPE_DD = 'policyTypes/RECEIVE_POLICY_TYPE_DD'; 